module.exports = __webpack_public_path__ + "static/media/trekspresso-2.0bcf108f.jpg";